<template>
<div>
    <!-- <p style="font-size:2em;">{{$store.state.qtyincreasetitle[$store.state.clct]}}</p> -->
    <p style="font-size:2em;">{{title}}</p>
    <qtychange :changer="changer" qtychange="qtyincrease" clctto="_in"></qtychange>
</div>
</template>

<script>
import qtychange from "./qtychange"
export default {
    components:{qtychange},
    data(){
        let actioninobj=this.$store.state.currentheader.find(ele=>{return ele.name==="actionin"})
        let changer=actioninobj.changer||"number"
        var gotocollection=this.$store.state.collections.find(obj=>{
            return obj.value===this.$store.state.clct+"_in"
        })
        return {
            title:gotocollection?gotocollection.label:"",
            changer:changer
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/qtychange/qtyincrease.vue